import { ActionTypes } from "../../constants/action-types";

const initialState = {
    user: [],
    is_user: false,
    profile: [],
    is_profile: false,
    notifications: []
};

export const userReducer = (state = initialState, { type, payload }) => {
    switch (type) {

        case ActionTypes.SET_USER:
            return {
                ...state,
                is_user: true,
                user: payload,
            };

        case ActionTypes.SET_PROFILE:
            return {
                ...state,
                is_profile: true,
                profile: payload,
            };

        case ActionTypes.SET_NOTIFICATIONS:
            return {
                ...state,
                notifications: payload,
            };

        case ActionTypes.CLEAR_PROFILE:
            return {
                ...state,
                profile: [],
            };

        case ActionTypes.RESET_STORE:
            return {
                ...(state = initialState),
            };

        default:
            return state;
    }
};
